import styled from 'styled-components'
import { breakpoints } from '../../constants'
import {
	BLUE,
	WHITE,
	MEDIUMORANGE,
	STRONGORANGE,
	PLACEHOLDERGRAY,
	INPUTGRAY,
	GREEN,
	GRAY,
	PRIMARY_COLOR,
	RED,
	DARKYELLOW,
	LIGHTGRAY,
	MEDIUMGRAY,
} from '../../styles/colors.style'

export const Container = styled.section`
	margin-top: 0;
	background: ${BLUE};
	display: flex;
	flex-direction: column;
	@media (min-width: ${breakpoints.MOBILE}px) {
		margin-top: -120px;
	}
`

export const Header = styled.header`
	background: ${MEDIUMORANGE};
	color: ${WHITE};
	height: 140px;
	text-align: center;

	&.hide {
		display: none;
	}

	h4 {
		font: bold 18px/33px 'Source Sans Pro';
		background: ${STRONGORANGE};
		height: 33px;
		width: 101px;
		margin: 0 auto;
	}
	p {
		font: bold 18px 'Source Sans Pro';
		max-width: 310px;
		margin: 12px auto;
	}

	@media (min-width: ${breakpoints.MOBILE}px) {
		height: 119px;
		width: 749px;
		margin: 0 auto 10px;
		border-radius: 0 0 32px 32px;

		p {
			max-width: 558px;
		}
	}
`
export const Register = styled.section`
	display: flex;
	flex-direction: column;
`

export const Paragraph = styled.p`
	width: 100% !important;
`

export const Steper = styled.nav`
	max-width: 342px;
	margin: 20px auto;

	&.hide {
		display: none;
	}

	ul {
		counter-reset: step;
		margin: 0;
		padding: 0;
		display: flex;

		li {
			list-style: none;
			color: ${WHITE};
			width: 33.3%;
			position: relative;
			text-align: center;

			&:before {
				content: counter(step);
				counter-increment: step;
				width: 30px;
				height: 30px;
				line-height: 27px;
				border: 2px solid transparent;
				display: block;
				text-align: center;
				margin: 0 auto 10px auto;
				border-radius: 50%;
				background: ${WHITE};
				color: ${BLUE};
				font-weight: 600;
				position: relative;
				z-index: 1;
			}
			&:after {
				content: '';
				position: absolute;
				width: 100%;
				height: 8px;
				background: ${WHITE};
				top: 12px;
				left: -50%;
				z-index: 0;
			}
			&:first-child {
				&:after {
					content: none;
				}
			}

			&.active {
				&:before {
					border-color: ${MEDIUMORANGE};
				}
			}

			&.active {
				+ {
					.active {
						&:after {
							background: ${MEDIUMORANGE};
						}
					}
				}
			}

			&.before {
				+ {
					.before {
						&:after {
							background: ${MEDIUMORANGE};
						}
					}
				}
				&:before {
					background: ${GREEN};
					color: ${WHITE};
					border-color: ${GREEN};
				}
			}
			&.before {
				+ {
					.active {
						&:after {
							background: ${MEDIUMORANGE};
						}
					}
				}
			}
		}
	}

	@media (min-width: ${breakpoints.MOBILE}px) {
	}
`
export const CustomizedErrorMessage = styled.div`
	color: #9d0000;
`

export const Box = styled.div`
	display: flex;
	flex-direction: column;
	color: ${WHITE};
	align-items: center;
	margin: 0 auto 40px auto;
	min-height: 30vh;

	@media (min-width: ${breakpoints.MOBILE}px) {
		width: 342px;
	}

	.safari-force-centering {
		margin: 0 auto !important;
	}

	.field {
		flex: 1;

		h5 {
			text-align: center;
			font: bold 18px/22px 'Source Sans Pro';
			margin-bottom: 20px;
		}

		.msg-error {
			color: ${RED};
			margin-bottom: 7px;
		}

		.no-cep {
			color: ${WHITE};
			font: 13px 'Source Sans Pro';
			align-self: flex-start;
			display: block;
			padding-bottom: 7px;

			&:hover {
				text-decoration: underline;
			}

			@media (min-width: ${breakpoints.MOBILE}px) {
			}
		}

		input {
			border-radius: 6px;
			background: ${WHITE};
			width: 100%;
			height: 45px;
			box-sizing: border-box;
			padding: 0 4px;
			border: 1px solid ${INPUTGRAY};
			outline: none;
			margin-bottom: 10px;
			font: 16px/45px 'Source Sans Pro';
			color: ${GRAY};

			&.input-medium {
				width: 262px;

				@media (min-width: ${breakpoints.MOBILE}px) {
					width: 342px;
				}
			}

			&.field-error {
				border: 1px solid ${PRIMARY_COLOR};
				box-shadow: 0 0 10px ${PRIMARY_COLOR};
			}

			&.input-big {
				width: 337px;
			}

			&::-webkit-input-placeholder {
				/* Edge */
				color: ${PLACEHOLDERGRAY};
				font: 16px/45px 'Source Sans Pro';
			}

			&:-ms-input-placeholder {
				/* Internet Explorer 10-11 */
				color: ${PLACEHOLDERGRAY};
				font: 16px/45px 'Source Sans Pro';
			}

			&::placeholder {
				color: ${PLACEHOLDERGRAY};
				font: 16px/45px 'Source Sans Pro';
			}
		}

		.terms {
			font: 16px/25px 'Source Sans Pro';
			margin: 10px 0;
			max-width: 337px;

			&:last-child {
				margin-bottom: 40px;
			}

			a,
			span {
				color: ${MEDIUMORANGE};
			}

			.input-check {
				position: absolute;
				opacity: 0;
				width: auto;

				& + label {
					position: relative;
					cursor: pointer;
					padding: 0;
				}
				& + label:before {
					content: '';
					margin-right: 10px;
					display: inline-block;
					vertical-align: text-top;
					width: 20px;
					height: 20px;
					background: transparent;
					border: 1px solid ${WHITE};
				}

				&:hover + label:before {
					background: transparent;
				}

				&:focus + label:before {
				}

				&:checked + label:before {
					background: transparent;
				}

				&:disabled + label {
					color: #b8b8b8;
					cursor: auto;
				}

				&:disabled + label:before {
					box-shadow: none;
					background: #ddd;
				}

				&:checked + label:after {
					content: '';
					position: absolute;
					left: 5px;
					top: 9px;
					background: ${MEDIUMORANGE};
					width: 2px;
					height: 2px;
					box-shadow: 2px 0 0 ${MEDIUMORANGE}, 4px 0 0 ${MEDIUMORANGE},
						4px -2px 0 ${MEDIUMORANGE}, 4px -4px 0 ${MEDIUMORANGE},
						4px -6px 0 ${MEDIUMORANGE}, 4px -8px 0 ${MEDIUMORANGE};
					transform: rotate(45deg);
				}
			}
		}

		fieldset {
			padding: 0;
			display: flex;
			border: 0;
			flex-wrap: wrap;

			.box-field {
				margin-bottom: 10px;
				width: 337px;
				display: flex;

				.row {
					width: 100%;
					.col {
						width: 100%;
					}
				}
				.col {
					width: 50%;
				}

				.numero {
					width: 80%;
				}

				@media (min-width: ${breakpoints.MOBILE}px) {
					width: 342px;
				}
			}
		}
	}

	.button {
		text-transform: uppercase;
		color: ${WHITE};
		background: ${MEDIUMORANGE};
		text-align: center;
		border: 0;
		width: 260px;
		height: 49px;
		border-radius: 5px;
		font: bold 16px/49px 'Source Sans Pro';
		cursor: pointer;

		&.transparent {
			background: transparent;
		}

		&.disabled {
			opacity: 0.5;
			cursor: initial;
		}
		&:disabled {
			opacity: 0.5;
			cursor: initial;
		}
	}

	.footer {
		display: flex;
		width: 100%;
		justify-content: space-between;
		flex-wrap: wrap;
		width: 90%;
		max-width: 300px;

		@media (min-width: ${breakpoints.MOBILE}px) {
			width: 100%;
			max-width: 342px;
		}

		button {
			width: auto;
			flex-grow: 1;

			&:first-child {
				margin-right: 20px;
			}
		}
	}
`

export const Choice = styled.section`
	display: flex;
	align-items: center;
	flex-direction: column;
	padding: 30px 0;
	height: 35vh;

	.box-choice {
		display: flex;

		.choices {
			background: ${WHITE};
			border-radius: 6px;
			height: 60px;
			width: 60px;
			border: 1px solid ${INPUTGRAY};
			margin: 0 10px;
			cursor: pointer;

			&.on {
				border: 5px solid ${DARKYELLOW};
				em {
					line-height: 50px;
				}
			}

			em {
				color: ${PLACEHOLDERGRAY};
				font: 25px/60px 'Source Sans Pro';
				text-align: center;
				display: block;
			}
		}
	}

	p {
		text-align: center;
		font: 600 22px/28px 'Source Sans Pro';
		width: 75%;
		margin: 0 auto 20px;
	}
`
export const ConclusionPage = styled.section`
	background: rgba(255, 255, 255, 0.9);
	top: 0;
	width: 100%;
	height: 100%;
	padding-top: 30px;
	@media (max-width: ${breakpoints.MOBILE}px) {
		padding-top: 10px;
	}
`

export const WaitingMessage = styled.div`
	display: flex;
	color: ${STRONGORANGE};
	height: 100%;
	align-items: center;
	&.waiting-message {
		background: rgba(255, 255, 255, 0.9);
		top: 0;
		padding-bottom: 15px;
		width: 100%;
		height: 100%;
		@media (min-width: ${breakpoints.MOBILE}px) {
			//desk
		}
	}

	.box-wait {
		margin: 0 auto;
		padding-bottom: 25px;
		text-align: center;
		height: fit-content;
		display: flex;
		justify-content: center;
		align-items: center;

		@media (max-width: ${breakpoints.MOBILE}px) {
			padding-bottom: 20px;
		}

		p {
			font: 600 20px/25px 'Source Sans Pro';
			text-align: center;
			padding: 0 25px;
			margin: 0 auto;

			small {
				display: block;
				color: ${MEDIUMGRAY};
				padding: 20px 55px;
			}
		}

		.footer-wait {
			display: flex;
			padding-top: 40px;

			.home {
				background: ${MEDIUMORANGE};
				color: ${WHITE};
				width: 260px;
				height: 50px;
				border-radius: 5px;
				font: 16px/50px 'Source Sans Pro';
				display: block;
				text-align: center;
				margin: 0 auto;
			}
		}

		.icon {
			font-size: 8em;
			margin: 0 auto 10px;
			display: flex;
			justify-content: center;
			color: ${LIGHTGRAY};

			&.animate {
				animation: fa-spin 3s infinite linear;
			}
			&.yellow {
				color: ${DARKYELLOW};
			}
			&.green {
				color: ${GREEN};
			}
		}
	}
`

export const ContainerPassword = styled.section`
	.button {
		text-transform: uppercase;
		color: ${WHITE};
		background: ${MEDIUMORANGE};
		text-align: center;
		border: 0;
		width: 260px;
		height: 49px;
		border-radius: 5px;
		font: bold 16px/49px 'Source Sans Pro';
		cursor: pointer;

		&.transparent {
			background: transparent;
		}

		&.disabled {
			opacity: 0.5;
			cursor: initial;
		}
		&:disabled {
			opacity: 0.5;
			cursor: initial;
		}
	}

	.footer {
		display: flex;
		width: 100%;
		justify-content: space-between;
		flex-wrap: wrap;
		width: 90%;
		max-width: 300px;
		margin: 0 auto;
		min-height: 10vh;

		@media (min-width: ${breakpoints.MOBILE}px) {
			width: 100%;
			max-width: 342px;
		}

		button {
			width: auto;
			flex-grow: 1;

			&:first-child {
				@media (min-width: ${breakpoints.MOBILE}px) {
					margin-right: 20px;
				}
			}
		}
	}
`

export const PasswordHeader = styled.header`
	@media (min-width: ${breakpoints.MOBILE}px) {
		margin: 0 auto;
		width: 749px;
	}
	h4 {
		text-align: center;
		font: 600 22px/33px 'Source Sans Pro';
		color: ${WHITE};
		background: ${MEDIUMORANGE};
		height: 131px;
		padding-top: 8px;

		@media (min-width: ${breakpoints.MOBILE}px) {
			border-radius: 0 0 32px 32px;
		}

		span {
			background: ${STRONGORANGE};
			padding: 0 5px;
		}
	}
`

export const PasswordSection = styled.section`
	height: 30vh;
	text-align: center;
	color: ${WHITE};
	display: flex;
	flex-direction: column;

	div {
		padding: 30px 0 0;
		position: relative;

		p {
			font: 600 22px 'Source Sans Pro';
		}
		.error {
			color: ${RED};
			font-size: medium;
		}

		input[type='password'] {
			border: 0;
			background: transparent;
			color: ${WHITE};
			height: 56px;
			letter-spacing: 10px;
			padding: 0;
			font: 29px 'Source Sans Pro';
			max-width: 240px;
			font-size: 80px !important; /*!important Needed for Safari*/
			outline: none;
			text-align: center;

			&::-webkit-input-placeholder {
				/* Edge */
				color: ${WHITE};
				font: 40px sans-serif;
			}

			&:-ms-input-placeholder {
				/* Internet Explorer 10-11 */
				color: ${WHITE};
				font: 40px sans-serif;
			}

			&::placeholder {
				color: ${WHITE};
				font: 40px sans-serif;
				transform: translate(0, -10px);
				font-weight: normal;
				font-style: normal;
			}
		}

		&:last-child {
			padding-top: 20px;
		}
	}
`
export const Card = styled.section`
	background: ${WHITE};
	padding: 20px;
`

export const BoxCard = styled.div`
	background: url('../assets/static/muvicard.png') no-repeat;
	background-size: cover;
	height: 219px;
	display: flex;
	align-items: flex-end;
	padding-bottom: 10px;
	margin: 0 auto;

	@media (min-width: ${breakpoints.MOBILE}px) {
		width: 342px;
	}

	ul {
		list-style: none;
	}
`

export const CardMessage = styled.p`
	font: 600 20px/25px 'Source Sans Pro';
	color: ${STRONGORANGE};
	text-align: center;
	padding-top: 20px;
`

export const LinkCard = styled.a`
	display: block;
	width: 260px;
	height: 50px;
	font: 600 16px/50px 'Source Sans Pro';
	text-align: center;
	border-radius: 5px;
	color: ${WHITE};
	margin: 15px auto;

	&.orange {
		background: ${MEDIUMORANGE};
	}
	&.blue {
		background: ${BLUE};
	}
	&:hover {
		color: ${WHITE};
		text-decoration: underline;
	}
`

export const ButtonLink = styled.button`
	background: none !important;
	border: none;
	padding: 0 !important;
	color: ${MEDIUMORANGE};
	cursor: pointer;
`
